var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c(_vm.componentName,{tag:"component",staticClass:"basic-wrapper form-wrapper",attrs:{"two-fa-response":_vm.twoFaResponse},on:{"continue-2fa":_vm.continue2fa}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }